import { render, staticRenderFns } from "./session_conflicts.vue?vue&type=template&id=32c25fe4&"
import script from "./session_conflicts.vue?vue&type=script&lang=js&"
export * from "./session_conflicts.vue?vue&type=script&lang=js&"
import style0 from "./session_conflicts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c25fe4')) {
      api.createRecord('32c25fe4', component.options)
    } else {
      api.reload('32c25fe4', component.options)
    }
    module.hot.accept("./session_conflicts.vue?vue&type=template&id=32c25fe4&", function () {
      api.rerender('32c25fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/conflicts/session_conflicts.vue"
export default component.exports